/* eslint-disable */
import kfext from '../kfext';

export default function(config) {
    const selfConfig = config.extendConfig;
    return new Promise((resolve, reject) => {
        const data = {
            selectKfext: selfConfig.userId || kfext.getCurrentId(),
            groupId: config.groupId || 0,
            page: config.parent.pageIndex ? Number(config.parent.pageIndex) + 1 : 0,
            pageSize: 20
        };
        _getGetListByGid(data).then(
            res => {
                if (res.data.list && res.data.list.length) {
                    let newList = res.data.list.map(x=>{
                        return {
                            ...x,
                            face: x.avatar,
                            extend: {
                                dbId: x.id
                            },
                            id: x.qq[0]
                        };
                    })                    
                    const result = Object.assign(res.data, {
                        list: newList
                    });
                    config.parent.pageIndex = res.data.page
                    resolve(result);
                } else {
                    resolve({
                        list: []
                    });
                }
            },
            err => {
                reject(err);
            }
        );
    });
}

function _getGetListByGid(data) {
    return Vue.prototype.$_sAjax.get('/cc/callContacts/GetListByGid', {
        params: data
    });
}
